import { TICKET_STATUSES, TICKET_PRIORITIES, TICKET_TYPES, CONTRACT_TYPES } from '../constants/statuses';
import { ROLES } from '../constants/roles';

const MOCK_TICKETS_STORAGE_KEY = 'amc_mock_tickets_v1';

const readPersistedMockTickets = () => {
  try {
    const raw = localStorage.getItem(MOCK_TICKETS_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    console.error('Failed to read persisted mock tickets:', error);
    return null;
  }
};

export const persistMockTickets = () => {
  try {
    localStorage.setItem(MOCK_TICKETS_STORAGE_KEY, JSON.stringify(mockTickets));
  } catch (error) {
    console.error('Failed to persist mock tickets:', error);
  }
};

// ============================================
// TEAM LEADS
// ============================================
export const mockTeamLeads = [
  {
    id: 2,
    name: 'Team Lead',
    email: 'tl@amc.com',
    contact: '9876543299',
    role: 'TL',
    department_id: 2,
    department: { id: 2, name: 'Field Operations' },
    is_active: true,
    engineers_count: 0,
    customers_count: 0,
    password_last_updated: new Date().toISOString(),
    is_locked_out: false,
    mfa_enabled: false
  },
  {
    id: 101,
    name: 'Sarah Johnson',
    email: 'sarah.tl@amc.com',
    contact: '9876543200',
    role: 'TL',
    department_id: 2,
    department: { id: 2, name: 'Field Operations' },
    is_active: true,
    engineers_count: 8,
    customers_count: 5,
    password_last_updated: new Date().toISOString(),
    is_locked_out: false,
    mfa_enabled: false
  },
  {
    id: 102,
    name: 'Mike Davis',
    email: 'mike.tl@amc.com',
    contact: '9876543201',
    role: 'TL',
    department_id: 2,
    department: { id: 2, name: 'Field Operations' },
    is_active: true,
    engineers_count: 6,
    customers_count: 4,
    password_last_updated: new Date().toISOString(),
    is_locked_out: false,
    mfa_enabled: false
  },
  {
    id: 103,
    name: 'David Wilson',
    email: 'david.tl@amc.com',
    contact: '9876543202',
    role: 'TL',
    department_id: 2,
    department: { id: 2, name: 'Field Operations' },
    is_active: true,
    engineers_count: 7,
    customers_count: 6,
    password_last_updated: new Date().toISOString(),
    is_locked_out: false,
    mfa_enabled: false
  }
];

// ============================================
// SITES
// ============================================
export const mockSites = [
  {
    id: 1,
    site_name: 'Tech Park - Bangalore',
    site_code: 'TP-BLR-001',
    customer_id: 1,
    address: '123, Electronic City Phase 1, Bangalore - 560100',
    contact_person: 'Ramesh Kumar',
    contact_phone: '9876543210',
    contact_email: 'ramesh@techcorp.com',
    city: 'Bangalore',
    state: 'Karnataka',
    pincode: '560100',
    is_active: true,
    systems_count: 12,
    active_tickets: 0,
    total_tickets: 0,
    last_service_date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    next_service_date: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 2,
    site_name: 'Main Office - Mumbai',
    site_code: 'MO-MUM-001',
    customer_id: 1,
    address: '456, Andheri East, Mumbai - 400069',
    contact_person: 'Priya Sharma',
    contact_phone: '9876543211',
    contact_email: 'priya@techcorp.com',
    city: 'Mumbai',
    state: 'Maharashtra',
    pincode: '400069',
    is_active: true,
    systems_count: 8,
    active_tickets: 0,
    total_tickets: 0,
    last_service_date: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    next_service_date: new Date(Date.now() + 40 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 300 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 3,
    site_name: 'Warehouse - Pune',
    site_code: 'WH-PUN-001',
    customer_id: 1,
    address: '789, Hinjewadi Phase 2, Pune - 411057',
    contact_person: 'Amit Patel',
    contact_phone: '9876543212',
    contact_email: 'amit@techcorp.com',
    city: 'Pune',
    state: 'Maharashtra',
    pincode: '411057',
    is_active: true,
    systems_count: 6,
    active_tickets: 0,
    total_tickets: 0,
    last_service_date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    next_service_date: new Date(Date.now() + 50 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 4,
    site_name: 'Retail Store - Delhi',
    site_code: 'RS-DEL-001',
    customer_id: 2,
    address: '321, Connaught Place, New Delhi - 110001',
    contact_person: 'Sneha Reddy',
    contact_phone: '9876543213',
    contact_email: 'sneha@retailsolutions.com',
    city: 'New Delhi',
    state: 'Delhi',
    pincode: '110001',
    is_active: true,
    systems_count: 5,
    active_tickets: 0,
    total_tickets: 0,
    last_service_date: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(),
    next_service_date: new Date(Date.now() + 35 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 5,
    site_name: 'Manufacturing Unit - Chennai',
    site_code: 'MU-CHE-001',
    customer_id: 3,
    address: '555, Ambattur Industrial Estate, Chennai - 600058',
    contact_person: 'Vikram Singh',
    contact_phone: '9876543214',
    contact_email: 'vikram@manufacturing.com',
    city: 'Chennai',
    state: 'Tamil Nadu',
    pincode: '600058',
    is_active: true,
    systems_count: 15,
    active_tickets: 0,
    total_tickets: 0,
    last_service_date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    next_service_date: new Date(Date.now() + 55 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 450 * 24 * 60 * 60 * 1000).toISOString()
  }
];

// ============================================
// GENERATE MOCK TICKETS (WITH SITES)
// ============================================
export const generateMockTickets = (count = 50) => {
  const tickets = [];
  const statuses = [
    TICKET_STATUSES.PENDING_ASSIGNMENT,
    TICKET_STATUSES.ASSIGNED,
    TICKET_STATUSES.WORK_IN_PROGRESS,
    TICKET_STATUSES.PENDING,
    TICKET_STATUSES.CLOSED
  ];
  const priorities = Object.values(TICKET_PRIORITIES);
  const types = Object.values(TICKET_TYPES);
  const systems = ['HVAC', 'Fire Alarm', 'Access Control', 'CCTV', 'Elevator', 'Generator'];

  for (let i = 1; i <= count; i++) {
    const createdDate = new Date();
    createdDate.setDate(createdDate.getDate() - Math.floor(Math.random() * 30));
    
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const isClosed = status === TICKET_STATUSES.CLOSED;
    
    // Randomly assign to one of the sites
    const site = mockSites[Math.floor(Math.random() * mockSites.length)];
    
    tickets.push({
      id: i,
      title: `${systems[Math.floor(Math.random() * systems.length)]} - ${['Not Working', 'Maintenance Required', 'Installation', 'Inspection'][Math.floor(Math.random() * 4)]}`,
      description: `Service request for ${systems[Math.floor(Math.random() * systems.length)]} system maintenance and inspection.`,
      source: 'Web',
      system_type: systems[Math.floor(Math.random() * systems.length)],
      manufacturer: ['Johnson Controls', 'Honeywell', 'Siemens', 'Schneider'][Math.floor(Math.random() * 4)],
      ticket_type: types[Math.floor(Math.random() * types.length)],
      priority: priorities[Math.floor(Math.random() * priorities.length)],
      site_id: site.id,
      site_name: site.site_name,
      customer_id: site.customer_id,
      department_id: Math.floor(Math.random() * 3) + 1,
      assignee_id: Math.random() > 0.3 ? Math.floor(Math.random() * 5) + 3 : null,
      assignee_name: Math.random() > 0.3 ? ['John Smith', 'Sarah Johnson', 'Mike Wilson', 'Emily Brown', 'David Lee'][Math.floor(Math.random() * 5)] : null,
      status: status,
      created_at: createdDate.toISOString(),
      closed_at: isClosed ? new Date().toISOString() : null,
      due_date: new Date(createdDate.getTime() + (48 * 60 * 60 * 1000)).toISOString(),
      metrics: {
        thread_count: Math.floor(Math.random() * 5),
        reopen_count: Math.floor(Math.random() * 2),
        attachment_count: Math.floor(Math.random() * 3),
        task_count: Math.floor(Math.random() * 5),
        sla_due_date: new Date(createdDate.getTime() + (48 * 60 * 60 * 1000)).toISOString(),
        sla_plan: '48 Hour Response',
        is_overdue: Math.random() > 0.7,
        is_merged: false,
        is_linked: Math.random() > 0.8,
        is_answered: Math.random() > 0.5,
        engineer_signature_s3_key: isClosed ? `signatures/eng_${i}.png` : null,
        customer_signature_s3_key: isClosed ? `signatures/cust_${i}.png` : null
      }
    });
  }
  
  return tickets;
};

// ============================================
// GENERATE MOCK CONTRACTS (WITH SITES)
// ============================================
export const generateMockContracts = (count = 30) => {
  const contracts = [];
  const types = Object.values(CONTRACT_TYPES);

  for (let i = 1; i <= count; i++) {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - Math.floor(Math.random() * 12));
    const endDate = new Date(startDate);
    endDate.setFullYear(endDate.getFullYear() + 1);
    
    const daysUntilExpiry = Math.floor((endDate - new Date()) / (1000 * 60 * 60 * 24));
    
    // Randomly assign to one of the sites
    const site = mockSites[Math.floor(Math.random() * mockSites.length)];
    
    const systems = ['CCTV', 'Access Control', 'Fire Alarm', 'HVAC', 'Elevator', 'Generator'];
    const selectedSystems = systems.filter(() => Math.random() > 0.5);
    const compCount = Math.floor(selectedSystems.length / 2);
    
    contracts.push({
      id: `AMC-2026-${String(i).padStart(4, '0')}`,
      value: Math.floor(Math.random() * 50000000) + 10000000,
      contract_type: types[Math.floor(Math.random() * types.length)],
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      services: {
        comprehensive: selectedSystems.slice(0, compCount),
        non_comprehensive: selectedSystems.slice(compCount)
      },
      site_id: site.id,
      customer_id: site.customer_id,
      company_name: site.customer_id === 1 ? 'Tech Corp Pvt Ltd' : site.customer_id === 2 ? 'Retail Solutions Inc' : 'Manufacturing Industries Ltd',
      site_name: site.site_name,
      status: daysUntilExpiry > 30 ? 'Active' : daysUntilExpiry > 0 ? 'Expiring Soon' : 'Expired',
      days_until_expiry: daysUntilExpiry,
      systems_covered: selectedSystems.length,
      tickets_this_month: Math.floor(Math.random() * 15)
    });
  }
  
  return contracts;
};

// ============================================
// GENERATE MOCK ENGINEERS (WITH TEAM LEADS)
// ============================================
export const generateMockEngineers = (count = 20) => {
  const engineers = [];
  const names = ['John Smith', 'Sarah Johnson', 'Mike Wilson', 'Emily Brown', 'David Lee', 'Anna Garcia', 'Tom Anderson', 'Lisa Martinez', 'Chris Taylor', 'Amy Thomas'];
  const locations = ['Site A', 'Site B', 'Site C', 'Office', 'Field'];
  const statuses = ['Active', 'Busy', 'Available', 'On Leave'];

  for (let i = 1; i <= count; i++) {
    let team_lead_id = null;
    let team_lead = null;
    
    if (Math.random() > 0.2) {
      const randomTL = mockTeamLeads[Math.floor(Math.random() * mockTeamLeads.length)];
      team_lead_id = randomTL.id;
      team_lead = {
        id: randomTL.id,
        name: randomTL.name,
        email: randomTL.email
      };
    }

    // Generate sample leave records for testing
    const leaves = [];
    
    // Active leave (for some engineers)
    if (i % 5 === 1) {
      leaves.push({
        id: Date.now() + i,
        start_date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
        end_date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days from now
        reason: 'Annual leave',
        created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        revoked_at: null
      });
    }

    // Upcoming leave (for some engineers)
    if (i % 7 === 1) {
      leaves.push({
        id: Date.now() + i + 1000,
        start_date: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(), // 15 days from now
        end_date: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(), // 20 days from now
        reason: 'Planned vacation',
        created_at: new Date().toISOString(),
        revoked_at: null
      });
    }

    // Completed leave (for some engineers)
    if (i % 6 === 1) {
      leaves.push({
        id: Date.now() + i + 2000,
        start_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
        end_date: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(), // 25 days ago
        reason: 'Medical leave',
        created_at: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString(),
        revoked_at: null
      });
    }

    // Revoked leave (for some engineers)
    if (i % 8 === 1) {
      leaves.push({
        id: Date.now() + i + 3000,
        start_date: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString(),
        end_date: new Date(Date.now() + 12 * 24 * 60 * 60 * 1000).toISOString(),
        reason: 'Cancelled leave',
        created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        revoked_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString() // revoked 1 day ago
      });
    }

    engineers.push({
      id: i + 2,
      name: names[Math.floor(Math.random() * names.length)] + ` ${i}`,
      email: `engineer${i}@amc.com`,
      contact: `98765432${String(i).padStart(2, '0')}`,
      role: ROLES.ENGINEER,
      department_id: 2,
      department: { id: 2, name: 'Field Operations' },
      is_active: Math.random() > 0.1,
      status: statuses[Math.floor(Math.random() * statuses.length)],
      location: locations[Math.floor(Math.random() * locations.length)],
      active_tickets: Math.floor(Math.random() * 8),
      completed_today: Math.floor(Math.random() * 5),
      completed_this_month: Math.floor(Math.random() * 50) + 20,
      performance_score: Math.floor(Math.random() * 20) + 80,
      avg_resolution_time: Math.floor(Math.random() * 48) + 12,
      password_last_updated: new Date().toISOString(),
      is_locked_out: false,
      mfa_enabled: false,
      team_lead_id: team_lead_id,
      team_lead: team_lead,
      leaves: leaves
    });
  }
  
  return engineers;
};

// ============================================
// GENERATE MOCK CUSTOMERS (WITH SITES)
// ============================================
export const generateMockCustomers = (count = 25) => {
  const customers = [];
  const companies = ['Tech Solutions Pvt Ltd', 'Retail Mart Inc', 'Manufacturing Corp', 'Healthcare Center', 'Finance Bank', 'Education Institute', 'Hospitality Group', 'Real Estate Ltd'];
  const contacts = ['Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy', 'Vijay Singh'];

  for (let i = 1; i <= count; i++) {
    const numSites = Math.floor(Math.random() * 3) + 1;
    const customerSites = [];
    for (let j = 0; j < numSites; j++) {
      const siteId = Math.floor(Math.random() * mockSites.length) + 1;
      if (!customerSites.includes(siteId)) {
        customerSites.push(siteId);
      }
    }

    customers.push({
      id: i,
      company_name: companies[Math.floor(Math.random() * companies.length)],
      contact_person: contacts[Math.floor(Math.random() * contacts.length)],
      email: `customer${i}@company.com`,
      contact: `91234567${String(i).padStart(2, '0')}`,
      role: ROLES.CUSTOMER,
      is_active: true,
      sites: customerSites,
      active_contracts: Math.floor(Math.random() * 3) + 1,
      total_sites: customerSites.length,
      open_tickets: 0,
      total_tickets: 0,
      contract_value: Math.floor(Math.random() * 100000000) + 20000000,
      joined_date: new Date(Date.now() - Math.random() * 365 * 24 * 60 * 60 * 1000).toISOString(),
      last_ticket: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString()
    });
  }
  
  return customers;
};

// ============================================
// INITIALIZE MOCK DATA
// ============================================
const persistedMockTickets = readPersistedMockTickets();
export const mockTickets = persistedMockTickets || generateMockTickets(50);
export const mockContracts = generateMockContracts(30);
export const mockEngineers = generateMockEngineers(20);

// Keep the default engineer account aligned with mock engineer data for predictable demos.
const defaultEngineerIndex = mockEngineers.findIndex((engineer) => engineer.id === 3);
if (defaultEngineerIndex !== -1) {
  mockEngineers[defaultEngineerIndex] = {
    ...mockEngineers[defaultEngineerIndex],
    id: 3,
    name: 'John Engineer',
    email: 'engineer@amc.com',
    status: 'Available',
    is_active: true,
    location: 'Field',
    leaves: [
      {
        id: 1001,
        start_date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
        end_date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
        reason: 'Annual leave',
        created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        revoked_at: null
      },
      {
        id: 1002,
        start_date: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(),
        end_date: new Date(Date.now() + 25 * 24 * 60 * 60 * 1000).toISOString(),
        reason: 'Planned vacation',
        created_at: new Date().toISOString(),
        revoked_at: null
      }
    ]
  };
}

let mockCustomers = generateMockCustomers(25);

// Override first 3 customers with specific data for testing
mockCustomers[0] = {
  id: 1,
  company_name: 'Tech Corp Pvt Ltd',
  contact_person: 'John Smith',
  email: 'john.smith@techcorp.com',
  contact: '9876543210',
  role: ROLES.CUSTOMER,
  is_active: true,
  sites: [1, 2, 3],
  active_contracts: 2,
  total_sites: 3,
  open_tickets: 0,
  total_tickets: 0,
  contract_value: 1500000,
  joined_date: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString(),
  last_ticket: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString()
};

mockCustomers[1] = {
  id: 2,
  company_name: 'Retail Solutions Inc',
  contact_person: 'Jane Doe',
  email: 'jane.doe@retail.com',
  contact: '9876543211',
  role: ROLES.CUSTOMER,
  is_active: true,
  sites: [4],
  active_contracts: 1,
  total_sites: 1,
  open_tickets: 0,
  total_tickets: 0,
  contract_value: 500000,
  joined_date: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString(),
  last_ticket: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString()
};

mockCustomers[2] = {
  id: 3,
  company_name: 'Manufacturing Industries Ltd',
  contact_person: 'Bob Wilson',
  email: 'bob.wilson@mfg.com',
  contact: '9876543212',
  role: ROLES.CUSTOMER,
  is_active: true,
  sites: [5],
  active_contracts: 2,
  total_sites: 1,
  open_tickets: 0,
  total_tickets: 0,
  contract_value: 2000000,
  joined_date: new Date(Date.now() - 450 * 24 * 60 * 60 * 1000).toISOString(),
  last_ticket: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString()
};

const buildMockCompaniesFromCustomers = () => {
  const companyMap = new Map();

  mockCustomers.forEach((customer) => {
    const name = (customer.company_name || '').trim();
    if (!name) {
      return;
    }

    if (!companyMap.has(name)) {
      companyMap.set(name, {
        id: companyMap.size + 1,
        company_name: name,
        total_sites: 0,
        active_contracts: 0,
        created_at: new Date().toISOString()
      });
    }

    const company = companyMap.get(name);
    company.total_sites += customer.total_sites || 0;
    company.active_contracts += customer.active_contracts || 0;
  });

  return Array.from(companyMap.values());
};

export let mockCompanies = buildMockCompaniesFromCustomers();

export const getMockCompanies = () => mockCompanies;

export const addMockCompany = (companyName) => {
  const normalizedName = (companyName || '').trim();

  if (!normalizedName) {
    return { success: false, error: 'Company name is required' };
  }

  const duplicate = mockCompanies.some(
    (company) => company.company_name.toLowerCase() === normalizedName.toLowerCase()
  );

  if (duplicate) {
    return { success: false, error: 'Company already exists' };
  }

  const maxId = mockCompanies.reduce((max, company) => Math.max(max, company.id), 0);
  const newCompany = {
    id: maxId + 1,
    company_name: normalizedName,
    total_sites: 0,
    active_contracts: 0,
    created_at: new Date().toISOString()
  };

  mockCompanies = [newCompany, ...mockCompanies];
  return { success: true, data: newCompany };
};

export { mockCustomers };

// ============================================
// HELPER FUNCTIONS
// ============================================

// Get sites by customer ID
export const getSitesByCustomerId = (customerId) => {
  const customer = mockCustomers.find(c => c.id === customerId);
  if (!customer) return [];
  return mockSites.filter(site => customer.sites.includes(site.id));
};

// Get tickets by site ID
export const getTicketsBySiteId = (siteId) => {
  return mockTickets.filter(ticket => ticket.site_id === siteId);
};

// Get contracts by site ID
export const getContractsBySiteId = (siteId) => {
  return mockContracts.filter(contract => contract.site_id === siteId);
};

// Get tickets by customer ID
export const getTicketsByCustomerId = (customerId) => {
  const customer = mockCustomers.find(c => c.id === customerId);
  if (!customer || !customer.sites) return [];
  
  return mockTickets.filter(ticket => customer.sites.includes(ticket.site_id));
};

// Get customer ticket stats
export const getCustomerTicketStats = (customerId) => {
  const tickets = getTicketsByCustomerId(customerId);
  const openTickets = tickets.filter(t => 
    [TICKET_STATUSES.PENDING_ASSIGNMENT, TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status)
  );
  const resolvedTickets = tickets.filter(t => 
    t.status === TICKET_STATUSES.CLOSED
  );
  const criticalTickets = tickets.filter(t => 
    t.priority === TICKET_PRIORITIES.CRITICAL && 
    t.status !== TICKET_STATUSES.CLOSED
  );
  
  return {
    total: tickets.length,
    open: openTickets.length,
    resolved: resolvedTickets.length,
    critical: criticalTickets.length
  };
};

// Get site statistics
export const getSiteStats = (siteId) => {
  const tickets = getTicketsBySiteId(siteId);
  const openTickets = tickets.filter(t => 
    [TICKET_STATUSES.PENDING_ASSIGNMENT, TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status)
  );
  const resolvedTickets = tickets.filter(t => 
    t.status === TICKET_STATUSES.CLOSED
  );
  
  return {
    total: tickets.length,
    open: openTickets.length,
    resolved: resolvedTickets.length
  };
};

// Get tickets history by month for a site (last 6 months)
export const getTicketsHistoryBySite = (siteId) => {
  const tickets = getTicketsBySiteId(siteId);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const now = new Date();
  const history = [];
  
  for (let i = 5; i >= 0; i--) {
    const monthDate = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const monthName = months[monthDate.getMonth()];
    const count = tickets.filter(t => {
      const ticketDate = new Date(t.created_at);
      return ticketDate.getMonth() === monthDate.getMonth() && 
             ticketDate.getFullYear() === monthDate.getFullYear();
    }).length;
    
    history.push({ month: monthName, count });
  }
  
  return history;
};

// Get tickets by priority for a site
export const getTicketsByPriorityForSite = (siteId) => {
  const tickets = getTicketsBySiteId(siteId);
  return [
    { priority: 'Low', count: tickets.filter(t => t.priority === TICKET_PRIORITIES.LOW).length },
    { priority: 'Medium', count: tickets.filter(t => t.priority === TICKET_PRIORITIES.MEDIUM).length },
    { priority: 'High', count: tickets.filter(t => t.priority === TICKET_PRIORITIES.HIGH).length },
    { priority: 'Critical', count: tickets.filter(t => t.priority === TICKET_PRIORITIES.CRITICAL).length }
  ];
};

// Get AMC status for a site
export const getAMCStatusForSite = (siteId) => {
  const site = mockSites.find(s => s.id === siteId);
  if (!site) return { status: 'Unknown', message: 'Site not found', color: '#6b7280' };
  
  const contracts = mockContracts
    .filter(c => c.site_id === siteId)
    .sort((a, b) => new Date(b.end_date) - new Date(a.end_date));
  
  const latest = contracts[0];
  
  if (latest) {
    const isExpired = new Date(latest.end_date) < new Date();
    const isActive = latest.status === 'Active' && !isExpired;
    
    return {
      status: isActive ? 'Active' : (isExpired ? 'Expired' : 'Inactive'),
      message: isExpired ? `Expired on ${new Date(latest.end_date).toLocaleDateString()}` : `Valid until ${new Date(latest.end_date).toLocaleDateString()}`,
      color: isActive ? '#10b981' : (isExpired ? '#ef4444' : '#6b7280'),
      services: latest.services,
      type: latest.contract_type,
      po_number: latest.id,
      start_date: latest.start_date,
      end_date: latest.end_date
    };
  }
  
  return {
    status: 'Inactive',
    message: 'No contract history',
    color: '#6b7280',
    services: null,
    type: null
  };
};

// Update site ticket counts
export const updateSiteTicketCounts = () => {
  mockSites.forEach(site => {
    const tickets = getTicketsBySiteId(site.id);
    const openTickets = tickets.filter(t => 
      [TICKET_STATUSES.PENDING_ASSIGNMENT, TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status)
    );
    site.total_tickets = tickets.length;
    site.active_tickets = openTickets.length;
  });
};

// Update customer ticket counts
export const updateCustomerTicketCounts = () => {
  mockCustomers.forEach(customer => {
    let totalTickets = 0;
    let openTickets = 0;
    
    customer.sites.forEach(siteId => {
      const tickets = getTicketsBySiteId(siteId);
      totalTickets += tickets.length;
      openTickets += tickets.filter(t => 
        [TICKET_STATUSES.PENDING_ASSIGNMENT, TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status)
      ).length;
    });
    
    customer.total_tickets = totalTickets;
    customer.open_tickets = openTickets;
  });
};

// Initialize counts
updateSiteTicketCounts();
updateCustomerTicketCounts();
persistMockTickets();

// ============================================
// DASHBOARD STATS
// ============================================

// Dashboard stats
export const getDashboardStats = (tickets) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  return {
    total_tickets: tickets.length,
    open_tickets: tickets.filter(t => [TICKET_STATUSES.PENDING_ASSIGNMENT, TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status)).length,
    closed_today: tickets.filter(t => {
      if (!t.closed_at) return false;
      const closedDate = new Date(t.closed_at);
      return closedDate >= today;
    }).length,
    critical_tickets: tickets.filter(t => t.priority === TICKET_PRIORITIES.CRITICAL && t.status !== TICKET_STATUSES.CLOSED).length,
    overdue_tickets: tickets.filter(t => t.metrics?.is_overdue && t.status !== TICKET_STATUSES.CLOSED).length,
    active_engineers: 18,
    avg_response_time: '2.5 hours',
    customer_satisfaction: 94
  };
};

// SLA Performance data
export const getSLAPerformance = () => {
  return [
    { month: 'Jan', met: 92, missed: 8 },
    { month: 'Feb', met: 89, missed: 11 },
    { month: 'Mar', met: 94, missed: 6 },
    { month: 'Apr', met: 91, missed: 9 },
    { month: 'May', met: 95, missed: 5 },
    { month: 'Jun', met: 93, missed: 7 }
  ];
};

// Daily ticket trend
export const getDailyTicketTrend = () => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  return days.map(day => ({
    day,
    created: Math.floor(Math.random() * 15) + 5,
    resolved: Math.floor(Math.random() * 12) + 3
  }));
};

// Export helper
export const generateMockTeamLeads = () => mockTeamLeads;


// ============================================
// ENGINEER HELPER FUNCTIONS
// ============================================

// Get engineer's assigned tickets
export const getEngineerTickets = (engineerId) => {
  const normalizedEngineerId = Number(engineerId);
  return mockTickets.filter((ticket) => Number(ticket.assignee_id) === normalizedEngineerId);
};

// Get engineer dashboard stats
export const getEngineerStats = (engineerId) => {
  const assignedTickets = getEngineerTickets(engineerId);
  const today = new Date().toDateString();
  
  const assignedToday = assignedTickets.filter(t => 
    new Date(t.created_at).toDateString() === today
  ).length;
  
  const inProgress = assignedTickets.filter(t => 
    t.status === TICKET_STATUSES.WORK_IN_PROGRESS
  ).length;
  
  const completedToday = assignedTickets.filter(t => 
    t.closed_at && new Date(t.closed_at).toDateString() === today
  ).length;
  
  // Calculate performance (SLA compliance)
  const totalClosed = assignedTickets.filter(t => t.status === TICKET_STATUSES.CLOSED).length;
  const onTime = assignedTickets.filter(t => 
    t.status === TICKET_STATUSES.CLOSED && !t.metrics?.is_overdue
  ).length;
  const performance = totalClosed > 0 ? Math.round((onTime / totalClosed) * 100) : 100;
  
  return {
    assignedToday,
    inProgress,
    completedToday,
    myPerformance: performance
  };
};

// Get engineer's weekly performance (last 7 days)
export const getEngineerWeeklyPerformance = (engineerId) => {
  const tickets = getEngineerTickets(engineerId);
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const today = new Date();
  const performance = [];
  
  for (let i = 6; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const dateString = date.toDateString();
    const dayName = i === 0 ? 'Today' : days[date.getDay()];
    
    const count = tickets.filter(t => 
      t.closed_at && new Date(t.closed_at).toDateString() === dateString
    ).length;
    
    performance.push({ day: dayName, count });
  }
  
  return performance;
};

// Get engineer's priority breakdown
export const getEngineerPriorityBreakdown = (engineerId) => {
  const tickets = getEngineerTickets(engineerId).filter(t => 
    t.status !== TICKET_STATUSES.CLOSED
  );
  
  return [
    { 
      priority: 'Critical', 
      count: tickets.filter(t => t.priority === TICKET_PRIORITIES.CRITICAL).length,
      color: '#ef4444' 
    },
    { 
      priority: 'High', 
      count: tickets.filter(t => t.priority === TICKET_PRIORITIES.HIGH).length,
      color: '#f97316' 
    },
    { 
      priority: 'Medium', 
      count: tickets.filter(t => t.priority === TICKET_PRIORITIES.MEDIUM).length,
      color: '#f59e0b' 
    },
    { 
      priority: 'Low', 
      count: tickets.filter(t => t.priority === TICKET_PRIORITIES.LOW).length,
      color: '#10b981' 
    }
  ];
};

// Get engineer's current active tickets
export const getEngineerCurrentTickets = (engineerId) => {
  return getEngineerTickets(engineerId)
    .filter(t => [TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status))
    .sort((a, b) => {
      // Sort by priority (Critical first)
      const priorityOrder = { 'CRITICAL': 0, 'HIGH': 1, 'MEDIUM': 2, 'LOW': 3 };
      return priorityOrder[a.priority] - priorityOrder[b.priority];
    })
    .slice(0, 5); // Top 5
};

// ============================================
// ENGINEER SCHEDULE DATA
// ============================================

// Generate mock schedule entries
export const generateEngineerSchedule = (engineerId) => {
  const today = new Date();
  const schedule = [];
  
  // Get engineer's tickets
  const engineerTickets = getEngineerTickets(engineerId).filter(t => 
    [TICKET_STATUSES.ASSIGNED, TICKET_STATUSES.WORK_IN_PROGRESS].includes(t.status)
  ).slice(0, 4); // Only take first 4 for today's schedule
  
  const times = ['09:00', '11:30', '14:00', '17:00'];
  const durations = [120, 90, 180, 60]; // minutes
  
  engineerTickets.forEach((ticket, index) => {
    const scheduledTime = new Date(today);
    const [hours, minutes] = times[index].split(':');
    scheduledTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    
    // Determine status
    let status = 'SCHEDULED';
    if (index === 0) {
      status = 'IN_PROGRESS';
    } else if (scheduledTime < new Date()) {
      status = 'COMPLETED';
    }
    
    schedule.push({
      id: index + 1,
      engineer_id: engineerId,
      ticket_id: ticket.id,
      ticket: ticket,
      scheduled_time: scheduledTime.toISOString(),
      duration_minutes: durations[index],
      task: ticket.title,
      customer_name: ticket.site_name,
      site_name: ticket.site_name,
      location: ticket.site_name,
      status: status,
      notes: ''
    });
  });
  
  return schedule;
};

// Get engineer's schedule for today
export const getEngineerTodaySchedule = (engineerId) => {
  return generateEngineerSchedule(engineerId);
};

// Get engineer's schedule stats
export const getEngineerScheduleStats = (engineerId) => {
  const schedule = getEngineerTodaySchedule(engineerId);
  
  const completed = schedule.filter(s => s.status === 'COMPLETED').length;
  const inProgress = schedule.filter(s => s.status === 'IN_PROGRESS').length;
  const upcoming = schedule.filter(s => s.status === 'SCHEDULED').length;
  
  const totalMinutes = schedule.reduce((sum, s) => sum + s.duration_minutes, 0);
  const totalHours = (totalMinutes / 60).toFixed(1);
  
  // Find next appointment
  const now = new Date();
  const nextAppointment = schedule
    .filter(s => s.status === 'SCHEDULED' && new Date(s.scheduled_time) > now)
    .sort((a, b) => new Date(a.scheduled_time) - new Date(b.scheduled_time))[0];
  
  let nextTime = '-';
  let nextIn = '-';
  if (nextAppointment) {
    const scheduledTime = new Date(nextAppointment.scheduled_time);
    nextTime = scheduledTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    
    const diffMs = scheduledTime - now;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
    if (diffHours > 0) {
      nextIn = `In ${diffHours}h ${diffMins}m`;
    } else {
      nextIn = `In ${diffMins}m`;
    }
  }
  
  return {
    scheduledToday: schedule.length,
    completed,
    inProgress,
    upcoming,
    totalHours,
    nextAppointmentTime: nextTime,
    nextAppointmentIn: nextIn
  };
};

// ============================================
// ENGINEER WORK REPORTS
// ============================================

export const generateWorkReports = (engineerId) => {
  const reports = [];
  const engineerTickets = getEngineerTickets(engineerId)
    .filter(t => t.status === TICKET_STATUSES.CLOSED)
    .slice(0, 10);
  
  engineerTickets.forEach((ticket, index) => {
    reports.push({
      id: index + 1,
      engineer_id: engineerId,
      ticket_id: ticket.id,
      ticket: ticket,
      work_description: `Completed ${ticket.system_type} maintenance work. Inspected all components and performed necessary adjustments.`,
      work_status: index % 4 === 0 ? 'PENDING_PARTS' : index % 3 === 0 ? 'PARTIALLY_COMPLETED' : 'COMPLETED',
      time_spent_hours: Math.floor(Math.random() * 4) + 1,
      parts_used: index % 2 === 0 ? 'Filter, Belt, Lubricant' : 'None',
      has_photos: Math.random() > 0.3,
      has_checklist: Math.random() > 0.2,
      has_signature: true,
      submitted_at: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
      status: index % 5 === 0 ? 'DRAFT' : index % 4 === 0 ? 'REJECTED' : index % 3 === 0 ? 'APPROVED' : 'UNDER_REVIEW'
    });
  });
  
  return reports;
};

export const getEngineerWorkReports = (engineerId) => {
  return generateWorkReports(engineerId);
};

export const getWorkReportableTickets = (engineerId) => {
  // Get tickets that are completed but don't have reports yet
  return getEngineerTickets(engineerId)
    .filter(t => [TICKET_STATUSES.WORK_IN_PROGRESS, TICKET_STATUSES.PENDING].includes(t.status));
};

// ============================================
// ENGINEER CHECKLISTS
// ============================================

export const checklistTypes = {
  'HVAC Maintenance': [
    'Check refrigerant levels',
    'Inspect compressor operation',
    'Clean or replace air filters',
    'Check thermostat calibration',
    'Inspect electrical connections',
    'Lubricate moving parts',
    'Check condensate drain',
    'Measure temperature differential',
    'Test safety controls',
    'Document system readings'
  ],
  'Fire System Inspection': [
    'Test smoke detectors',
    'Inspect fire extinguishers',
    'Check fire alarm panel',
    'Test emergency lights',
    'Inspect sprinkler heads',
    'Check water pressure',
    'Test alarm bells/horns',
    'Verify exit signage',
    'Document battery backup',
    'Complete inspection report'
  ],
  'Electrical Safety': [
    'Inspect circuit breakers',
    'Check ground connections',
    'Test GFCI outlets',
    'Inspect electrical panels',
    'Check wire insulation',
    'Test emergency power',
    'Verify load balancing',
    'Inspect conduit systems',
    'Document voltage readings',
    'Complete safety certification'
  ],
  'Preventive Maintenance': [
    'Visual equipment inspection',
    'Check fluid levels',
    'Inspect belts and hoses',
    'Test control systems',
    'Clean equipment surfaces',
    'Check for leaks',
    'Measure vibration levels',
    'Lubricate bearings',
    'Test safety interlocks',
    'Update maintenance log'
  ]
};

export const getChecklistTypes = () => {
  return Object.keys(checklistTypes);
};

export const getChecklistItems = (checklistType) => {
  return checklistTypes[checklistType] || [];
};

// Get saved checklist progress from localStorage
export const getChecklistProgress = (checklistType) => {
  const saved = localStorage.getItem(`checklist_${checklistType}`);
  return saved ? JSON.parse(saved) : {};
};

// Save checklist progress to localStorage
export const saveChecklistProgress = (checklistType, progress) => {
  localStorage.setItem(`checklist_${checklistType}`, JSON.stringify(progress));
};


// ============================================
// ENGINEER KNOWLEDGE BASE
// ============================================

export const knowledgeBaseCategories = [
  { id: 1, name: 'Standard Procedures', icon: 'PROC', articleCount: 12 },
  { id: 2, name: 'Troubleshooting', icon: 'TOOL', articleCount: 18 },
  { id: 3, name: 'Safety Guides', icon: 'SAFE', articleCount: 8 },
  { id: 4, name: 'Emergency Contacts', icon: 'CALL', articleCount: 4 }
];

export const knowledgeBaseArticles = [
  {
    id: 1,
    category: 'Installation',
    title: 'Standard Equipment Installation Procedure',
    description: 'Complete guide for equipment installation including safety checks and verification steps',
    content: 'Full article content here...',
    views: 245,
    helpful: 189,
    created_at: '2024-01-10T10:00:00Z',
    updated_at: '2024-01-15T14:30:00Z'
  },
  {
    id: 2,
    category: 'Troubleshooting',
    title: 'Common Equipment Faults and Solutions',
    description: 'Quick reference guide for identifying and resolving common equipment issues',
    content: 'Full article content here...',
    views: 312,
    helpful: 278,
    created_at: '2024-01-08T09:00:00Z',
    updated_at: '2024-01-12T16:45:00Z'
  },
  {
    id: 3,
    category: 'Maintenance',
    title: 'Preventive Maintenance Checklist',
    description: 'Scheduled maintenance procedures and inspection points for all equipment types',
    content: 'Full article content here...',
    views: 198,
    helpful: 165,
    created_at: '2024-01-05T11:30:00Z',
    updated_at: '2024-01-10T13:20:00Z'
  },
  {
    id: 4,
    category: 'Safety',
    title: 'Safety Guidelines and Emergency Procedures',
    description: 'Essential safety protocols and emergency response procedures for field engineers',
    content: 'Full article content here...',
    views: 420,
    helpful: 398,
    created_at: '2024-01-03T08:15:00Z',
    updated_at: '2024-01-08T10:00:00Z'
  },
  {
    id: 5,
    category: 'Tools',
    title: 'Required Tools and Equipment List',
    description: 'Comprehensive list of tools and equipment needed for various service tasks',
    content: 'Full article content here...',
    views: 156,
    helpful: 134,
    created_at: '2024-01-01T12:00:00Z',
    updated_at: '2024-01-05T15:30:00Z'
  }
];

export const emergencyContacts = [
  { id: 1, title: 'Team Leader', name: 'Rohit Sharma', phone: '+91 98765 43210', email: 'rohit@amc.com' },
  { id: 2, title: 'Technical Support', name: 'Support Team', phone: '+91 98765 43211', email: 'support@amc.com' },
  { id: 3, title: 'Emergency Hotline', name: '24/7 Support', phone: '1800-123-4567', email: 'emergency@amc.com' },
  { id: 4, title: 'Parts Department', name: 'Inventory Team', phone: '+91 98765 43212', email: 'parts@amc.com' }
];

export const getKnowledgeBaseCategories = () => {
  return knowledgeBaseCategories;
};

export const getKnowledgeBaseArticles = (searchTerm = '') => {
  if (!searchTerm) return knowledgeBaseArticles;
  
  const term = searchTerm.toLowerCase();
  return knowledgeBaseArticles.filter(article => 
    article.title.toLowerCase().includes(term) ||
    article.description.toLowerCase().includes(term) ||
    article.category.toLowerCase().includes(term)
  );
};

export const getKnowledgeBaseArticle = (articleId) => {
  return knowledgeBaseArticles.find(a => a.id === articleId);
};

export const getEmergencyContacts = () => {
  return emergencyContacts;
};